/* ============================================================
   FOS — UGC Slider + quick-shop paneli
   Sepete ekleme go_cart.js delegation'ına bırakılır:
   .js-go-cart-add-to-cart tıklaması form'u /cart/add.js'e gönderir,
   sepet çekmecesini açar ve document'a 'cart:itemAdded' yayınlar.
   ============================================================ */
(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.fosUgcInit === 'true') return;
    root.dataset.fosUgcInit = 'true';

    initSlider(root);
    initQuickShop(root);
  }

  /* ---------- Şerit okları ---------- */
  function initSlider(root) {
    var track = root.querySelector('[data-ugc-track]');
    if (!track) return;
    var prev = root.querySelector('[data-ugc-arrow="prev"]');
    var next = root.querySelector('[data-ugc-arrow="next"]');
    if (!prev || !next) return;

    function update() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      prev.hidden = !overflow;
      next.hidden = !overflow;
      if (!overflow) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ---------- Quick-shop ---------- */
  function initQuickShop(root) {
    var qs = root.querySelector('[data-fos-qs]');
    if (!qs) return;

    var lookArea = qs.querySelector('[data-qs-look]');
    var lookGrid = qs.querySelector('[data-qs-look-grid]');
    var gallery = qs.querySelector('[data-qs-gallery]');
    var lastFocused = null;

    /* Panel başına ilk fiyat HTML'ini sakla (reset için) */
    qs.querySelectorAll('[data-qs-prod]').forEach(function (panel) {
      var price = panel.querySelector('[data-qs-price]');
      if (price) panel.__initialPriceHTML = price.innerHTML;
    });

    function open(productIds) {
      lastFocused = document.activeElement;
      resetPanels(productIds);
      buildLookThumbs(productIds);
      activateProduct(productIds[0]);
      qs.classList.add('is-open');
      qs.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fos-qs-open');
      var closeBtn = qs.querySelector('[data-qs-close][aria-label]') || qs.querySelector('.fos-qs__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function close() {
      qs.classList.remove('is-open');
      qs.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fos-qs-open');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
    }

    function panelFor(pid) {
      return qs.querySelector('[data-qs-prod="' + pid + '"]');
    }

    function resetPanels(productIds) {
      productIds.forEach(function (pid) {
        var panel = panelFor(pid);
        if (!panel) return;

        panel.querySelectorAll('.fos-qs__size.is-selected').forEach(function (b) {
          b.classList.remove('is-selected');
        });

        var form = panel.querySelector('.fos-qs__form');
        var selectBtn = panel.querySelector('[data-qs-select-size]');
        if (form && selectBtn) {
          form.hidden = true;
          selectBtn.hidden = false;
          selectBtn.textContent = selectBtn.dataset.originalLabel || selectBtn.textContent;
          var input = form.querySelector('[data-qs-variant-input]');
          if (input) input.value = '';
        }

        var atc = panel.querySelector('.js-go-cart-add-to-cart');
        if (atc) {
          atc.classList.remove('is-loading');
          if (atc.dataset.qsOriginalText) atc.textContent = atc.dataset.qsOriginalText;
        }

        var price = panel.querySelector('[data-qs-price]');
        if (price && panel.__initialPriceHTML) price.innerHTML = panel.__initialPriceHTML;
      });
    }

    function buildLookThumbs(productIds) {
      if (!lookArea || !lookGrid) return;
      lookGrid.innerHTML = '';
      if (productIds.length < 2) {
        lookArea.hidden = true;
        return;
      }
      productIds.forEach(function (pid) {
        var panel = panelFor(pid);
        if (!panel) return;
        var thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'fos-qs__look-thumb';
        thumb.setAttribute('data-qs-thumb', pid);
        thumb.setAttribute('aria-label', panel.dataset.title || '');
        var img = document.createElement('img');
        img.src = panel.dataset.thumb || '';
        img.alt = panel.dataset.title || '';
        img.loading = 'lazy';
        thumb.appendChild(img);
        thumb.addEventListener('click', function () {
          activateProduct(pid);
        });
        lookGrid.appendChild(thumb);
      });
      lookArea.hidden = false;
    }

    function activateProduct(pid) {
      qs.querySelectorAll('[data-qs-prod]').forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.qsProd === String(pid));
      });
      qs.querySelectorAll('[data-qs-media]').forEach(function (m) {
        m.classList.toggle('is-active', m.dataset.qsMedia === String(pid));
      });
      qs.querySelectorAll('[data-qs-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t.dataset.qsThumb === String(pid) ? 'true' : 'false');
      });
      if (gallery) gallery.scrollTop = 0;

      var panel = panelFor(pid);
      if (panel) {
        var info = panel.closest('.fos-qs__info');
        if (info) info.scrollTop = 0;
        setupMobileDots(panel);
      }
    }

    /* Mobil galeri noktaları — ilk aktivasyonda kur */
    function setupMobileDots(panel) {
      var mgallery = panel.querySelector('[data-qs-mgallery]');
      if (!mgallery || mgallery.dataset.dotsReady === 'true') return;
      mgallery.dataset.dotsReady = 'true';

      var mtrack = mgallery.querySelector('[data-qs-mtrack]');
      var dotsWrap = mgallery.querySelector('[data-qs-mdots]');
      if (!mtrack || !dotsWrap) return;
      var slides = mtrack.querySelectorAll('.fos-qs__mslide');
      if (slides.length < 2) return;

      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fos-qs__mdot' + (i === 0 ? ' is-active' : '');
        var i18n = window.fosI18n || {};
        var dotLabel = (typeof i18n.imageN === 'string' && i18n.imageN) ? i18n.imageN : 'Görsel __N__';
        dot.setAttribute('aria-label', dotLabel.split('__N__').join(i + 1));
        dot.addEventListener('click', function () {
          mtrack.scrollTo({ left: i * mtrack.clientWidth, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });

      mtrack.addEventListener(
        'scroll',
        function () {
          var index = Math.round(mtrack.scrollLeft / Math.max(mtrack.clientWidth, 1));
          dotsWrap.querySelectorAll('.fos-qs__mdot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === index);
          });
        },
        { passive: true }
      );
    }

    /* Foto tıklamaları */
    root.querySelectorAll('[data-ugc-open]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        var ids = (tile.dataset.products || '')
          .split(',')
          .map(function (s) { return s.trim(); })
          .filter(Boolean)
          .filter(function (pid) { return !!panelFor(pid); });
        if (!ids.length) return;
        open(ids);
      });
    });

    /* Kapatma yolları */
    qs.querySelectorAll('[data-qs-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && qs.classList.contains('is-open')) close();
    });

    /* Panel içi etkileşimler (delegation) */
    qs.addEventListener('click', function (e) {
      var size = e.target.closest('.fos-qs__size');
      if (size && !size.classList.contains('out-of-stock')) {
        selectSize(size);
        return;
      }

      var selectBtn = e.target.closest('[data-qs-select-size]');
      if (selectBtn) {
        if (!selectBtn.dataset.originalLabel) {
          selectBtn.dataset.originalLabel = selectBtn.textContent.trim();
        }
        selectBtn.textContent = selectBtn.dataset.selectLabel || selectBtn.textContent;
        var sizes = selectBtn.closest('[data-qs-prod]').querySelector('[data-qs-sizes]');
        if (sizes) {
          sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
          sizes.classList.remove('is-pulsing');
          void sizes.offsetWidth;
          sizes.classList.add('is-pulsing');
        }
        return;
      }

      var atc = e.target.closest('.js-go-cart-add-to-cart');
      if (atc && !atc.classList.contains('is-loading')) {
        /* go_cart.js document listener'ı formu gönderecek; burada sadece görsel durum */
        atc.dataset.qsOriginalText = atc.textContent;
        atc.classList.add('is-loading');
        atc.innerHTML = '<span class="fos-qs__spinner" aria-hidden="true"></span>';
        /* go_cart hata verirse (event gelmezse) butonu geri al */
        setTimeout(function () {
          if (atc.classList.contains('is-loading')) {
            atc.classList.remove('is-loading');
            atc.textContent = atc.dataset.qsOriginalText;
          }
        }, 8000);
      }
    });

    function selectSize(sizeBtn) {
      var panel = sizeBtn.closest('[data-qs-prod]');
      if (!panel) return;

      panel.querySelectorAll('.fos-qs__size').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      sizeBtn.classList.add('is-selected');

      var form = panel.querySelector('.fos-qs__form');
      var selectBtn = panel.querySelector('[data-qs-select-size]');
      var input = panel.querySelector('[data-qs-variant-input]');
      if (input) input.value = sizeBtn.dataset.id || '';
      if (form) form.hidden = false;
      if (selectBtn) selectBtn.hidden = true;

      updatePrice(panel, sizeBtn);
    }

    /* Varyant fiyatı ürün fiyatından farklıysa paneldeki fiyatı güncelle */
    function updatePrice(panel, sizeBtn) {
      var priceRoot = panel.querySelector('[data-qs-price] .price');
      if (!priceRoot) return;

      var price = sizeBtn.dataset.price;
      var compare = sizeBtn.dataset.compare;
      if (!price) return;

      var badge = priceRoot.querySelector('.discount-badge');

      if (compare) {
        priceRoot.classList.add('price--on-sale');
        var compareEl = priceRoot.querySelector('.price__sale s.price-item--regular');
        var saleEl = priceRoot.querySelector('.price-item--sale');
        if (compareEl) compareEl.textContent = compare;
        if (saleEl) saleEl.textContent = price;

        var cents = parseFloat(sizeBtn.dataset.priceCents);
        var compareCents = parseFloat(sizeBtn.dataset.compareCents);
        if (badge && cents && compareCents) {
          badge.textContent = '-%' + Math.round(((compareCents - cents) * 100) / compareCents);
          badge.style.display = '';
        }
      } else {
        priceRoot.classList.remove('price--on-sale');
        var regularEl = priceRoot.querySelector('.price__regular .price-item--regular');
        if (regularEl) regularEl.textContent = price;
        if (badge) badge.style.display = 'none';
      }
    }

    /* go_cart başarıyla ekledi → paneli kapat, buton durumunu geri al */
    document.addEventListener('cart:itemAdded', function () {
      if (!qs.classList.contains('is-open')) return;
      var atc = qs.querySelector('.js-go-cart-add-to-cart.is-loading');
      if (atc) {
        atc.classList.remove('is-loading');
        if (atc.dataset.qsOriginalText) atc.textContent = atc.dataset.qsOriginalText;
      }
      close();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fos-ugc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Tema editörü section'ı yeniden render edince */
  document.addEventListener('shopify:section:load', initAll);
})();
